/** 逻辑 field key，供 accessPolicy / registerCapability.fields 使用 */
export const SYSTEM_DISK_SIZE_FIELD_KEYS = {
  size: 'systemDiskSize',
} as const;

export const SYSTEM_DISK_SIZE_FIELD_KEY_LIST = [SYSTEM_DISK_SIZE_FIELD_KEYS.size] as const;

/** 下单有预置时由 lockActionsWhenFilled 隐藏编辑/删除 */
export const SYSTEM_DISK_SIZE_ACTION_KEYS = {
  edit: 'systemDiskSize.edit',
  remove: 'systemDiskSize.remove',
} as const;

export const SYSTEM_DISK_SIZE_ACTION_KEY_LIST = Object.values(SYSTEM_DISK_SIZE_ACTION_KEYS);
